<template>
<div class="bg-white">
    <div class="mianbaox" >
        <el-breadcrumb class="padding-tb" separator-class="el-icon-arrow-right" style="cursor: default;max-width: 1180px;margin: 0 auto;">
            <div class="font-13" style="float: left">当前位置：</div>
            <el-breadcrumb-item class="font-13" style="cursor: pointer"><span @click="$router.push({path: '/'})">首页</span></el-breadcrumb-item>
            <el-breadcrumb-item class="font-13">地域列表</el-breadcrumb-item>
            <el-breadcrumb-item class="font-13">地域详情</el-breadcrumb-item>
        </el-breadcrumb>
    </div>
    <div class="flex justify-center mianbaox">
<!--        图片视图，控制栏-->
        <scroll :scrollData="scrollData" :isvr="isvrStatus" :urlData="vrUrlData"></scroll>
<!-- 左侧控制栏 -->
        <div class="nvaItem" style="">
            <div class="seeType">选择看地方式</div>
            <div>
                <div class="nvatitle " @mousemove="ismousemove(i)" @mouseleave="ismouseleave(i)" @click="isClorC(i)" v-for="(item,i) in nvatitle1" :key="i" v-if="item.isShow" :class="item.isClor?'text-red':''">
                    <img :src="item.img" alt=""><li>{{item.title}}</li><div style="padding-top: 5px;padding-left: 160px">{{item.value}}</div>
                </div>
            </div>
            <img src="../../assets/svg/hfgf.svg" alt="">
            <div style="text-align: left;padding-left: 15px;">
                <li class="content-info font-15" style="color: #333;" v-for="(item,i) in contentInfo" :key="i" v-html="item"></li>
            </div>
        </div>
    </div>

    <!--    移动设备视图-->
    <div class="phoneView vrinfocrat" style="margin-top: 10px ">
        <div class="phone-bg" style="text-align: left;">
            <li class="content-info" v-for="(item,i) in contentInfo" :key="i" v-html="item"></li>
        </div>
<!--        实景图-->
        <div v-if="queryData.coverList.length >0" class="phone-bg">
            <div class="nvatitle1 ">
                <img src="../../assets/vritem/u1.svg" alt=""><li>实景图</li>
            </div>
            <div>
                <el-carousel height="253" :interval="5000" arrow="always" :autoplay="false" :loop="false">
                    <el-carousel-item v-for="item in queryData.coverList" :key="item">
                        <img :src="item" class="item-imgs" preview="0" preview-text="实景图" style=" max-height:353px;width: 100%;background-size: 100% 100%" alt="">
                    </el-carousel-item>
                </el-carousel>
            </div>
        </div>
        <!--        区位图-->
        <div v-if="queryData.locationList.length >0" class="phone-bg">
            <div class="nvatitle1 " >
                <img src="../../assets/vritem/u2.svg" alt=""><li>区位图</li>
            </div>
            <div>
                <el-carousel height="253" :interval="5000" arrow="always" :loop="false" :autoplay="false">
                    <el-carousel-item v-for="item in queryData.locationList" :key="item">
                        <img :src="item" class="item-imgs" preview="1" preview-text="区位图" style=" max-height:353px;width: 100%;background-size: 100% 100%" alt="">
                    </el-carousel-item>
                </el-carousel>
            </div>
        </div>
        <!--        落位图-->
        <div v-if="queryData.fallList.length >0"  class="phone-bg">
            <div class="nvatitle1 ">
                <img src="../../assets/vritem/u2.svg" alt=""><li>落位图</li>
            </div>
            <div>
                <el-carousel height="253" :interval="5000" arrow="always" :loop="false" :autoplay="false">
                    <el-carousel-item v-for="(item,i) in queryData.fallList" :key="i">
                        <img :src="item" class="item-imgs" preview="2" preview-text="落位图" style=" max-height:353px;width: 100%;background-size: 100% 100%" alt="">
                    </el-carousel-item>
                </el-carousel>
            </div>
        </div>
        <!--        控规图-->
        <div v-if="queryData.rulesList.length >0" class="phone-bg">
            <div class="nvatitle1 ">
                <img src="../../assets/vritem/u2.svg" alt=""><li>控规图</li>
            </div>
            <div>
                <el-carousel height="253" :interval="5000" arrow="always" :loop="false" :autoplay="false">
                    <el-carousel-item v-for="(item,i) in queryData.rulesList" :key="i">
                        <img :src="item" class="item-imgs" preview="3" preview-text="控规图" style=" max-height:353px;width: 100%;background-size: 100% 100%" alt="">
                    </el-carousel-item>
                </el-carousel>
            </div>
        </div>
        <!--        vr全景图-->
        <div v-if="queryData.vrList.length >0" class="phone-bg">
            <div class="nvatitle1 ">
                <img src="../../assets/vritem/u2.svg" alt=""><li>VR全景图</li>
            </div>
            <div>
                <el-carousel height="253" :interval="5000" arrow="always" :loop="false" :autoplay="false">
                    <el-carousel-item v-for="(item,i) in scrollDataPE" :key="i" >
                        <img :src="item" class="item-imgs" @click="toVR(item,i)" preview-text="全景图" style=" max-height:353px;width: 100%;background-size: 100% 100%" alt="">
                    </el-carousel-item>
                </el-carousel>
            </div>
        </div>
    </div>


<!--    pc简绍区域-->
    <!-- <div class="mianbaox" style="max-width: 1180px; border-top: 1px #b6b6b6 solid;margin: 30px auto"></div> -->
    <div class="nullBox"></div>
    <div class="vrinfocrat " style="max-width: 1180px;margin: 0 auto;" v-if="false">
        <div  v-for="(item,i) in shuomin" :key="i" class="phone-bg">
            <div class="flex justify-start">
                <div class="xmujs"></div>
                <div class="text-left text-bold" style="font-size: 17px;">{{item.title}}</div>
            </div>
            <div class="text-left" v-for="(item1,i) in item.value" :key="i">
                <div class="text-bold" style="padding-top: 15px;padding-bottom: 8px">{{item1.value11}}</div>
                <div style="font-size: 13px;color: rgba(60, 60, 67, 0.6);">{{item1.value12}}</div>
                <div class="text-bold" style="padding-top: 15px;padding-bottom: 8px">{{item1.value21}}</div>
                <div style="font-size: 13px;color: rgba(60, 60, 67, 0.6);">{{item1.value22}}</div>
                <div class="text-bold" style="padding-top: 15px;padding-bottom: 8px">{{item1.value31}}</div>
                <div style="font-size: 13px;color: rgba(60, 60, 67, 0.6);">{{item1.value32}}</div>
            </div>
        </div>
    </div>

<!--    <li>动态路由传参query{{$route.query}}</li>-->
</div>
</template>

<script>
    import scroll from "@/components/scroll";
    export default {
        name: "vrinfo",
        components: {
            scroll,
        },
        data() {
            // 导航图标
            const navimgData = [
                    {img:require('../../assets/vritem/u1.svg'),title:'实景图',value:0,isClor:true,isShow:true},
                    {img:require('../../assets/vritem/u2.svg'),title:'区位图',value:0,isClor:false,isShow:true},
                    {img:require('../../assets/vritem/u3.svg'),title:'落位图',value:0,isClor:false,isShow:true},
                    {img:require('../../assets/vritem/u4.svg'),title:'控规图',value:0,isClor:false,isShow:true},
                    {img:require('../../assets/vritem/u5.svg'),title:'全景图',value:0,isClor:false,isShow:true},
                ]
            return {
                srcIndex:'https://axure.tdin360.com/kdxt/images/详情/图片_u996.jpeg',
                srcList:['https://axure.tdin360.com/kdxt/images/详情/图片_u996.jpeg',
                    'https://axure.tdin360.com/kdxtsj/images/详情/图片_u508.jpeg'],
                nvatitle1:navimgData, // 导航图标
                contentInfo:[],
                shuomin:[],
                scrollData:[],
                queryData:null,
                isvrStatus:false, //是否是vr
                vrUrlData:[],
                scrollDataPE:[]
            }
        },
        created() {
            var data1 = this.$route.query.data // 路由传值
            console.log('路由传值',JSON.stringify(data1))
            this.$storage.setLocalStorage('vrinfoId',data1)
            this.$http({
                url: this.$Api.getDetail,
                params:{
                    id:this.$storage.getLocalStorage('vrinfoId')
                }
            }).then((res)=>{
                console.log('数据详情',res)
                var data = res.data[0]

                // 长度
                this.nvatitle1[0].value = data.coverList.length;
                this.nvatitle1[1].value = data.locationList.length;
                this.nvatitle1[2].value = data.fallList.length;
                this.nvatitle1[3].value = data.rulesList.length;
                this.nvatitle1[4].value = data.vrList.length;

                // 类型
                if(data.nature === '0')data.nature = '居住';
                if(data.nature === '1')data.nature = '商住';
                if(data.nature === '2')data.nature = '商业';
                if(data.nature === '3')data.nature = '商务';
                if(data.nature === '4')data.nature = '工业';
                if(data.nature === '5')data.nature = '其他';

                // 内存存储
                this.queryData = data
                this.scrollData = data.coverList

                // 默认图片
                // if(data.coverList.length === 0){}
                // if(data.locationList.length === 0){}
                // if(data.fallList.length === 0){}
                // if(data.rulesList.length === 0){}
                // if(data.vrList.length === 0){}

                data.vrList.forEach((item,index)=>{
                    this.scrollDataPE.push(item.vrCoverImgUrl) // 封面
                    this.vrUrlData.push(item.vrImgUrl) // 跳转地址
                })
                if(data.vrList.length ===0){
                    this.nvatitle1[4].isShow = false
                }
                // 渲染
                this.contentInfo = [
                    data.name,
                    '项目编号：'+data.numberNo || '-',
                    '项目地址：'+data.address || '-',
                    '归属地：'+(data.province || '-' )+(data.city || '-') +(data.county || '-') ,
                    '四至：'+(data.fourTo || '-'),
                    '用地性质：'+data.nature || '-',
                    data.areaLand?'占地面积：'+data.areaLand + '亩（'+ ((JSON.parse(data.areaLand) / 15 * 10000).toFixed(2) +'m<sup>2</sup>）'):'占地面积：-',
                    data.areaMeter?'计容建面：'+data.areaMeter+'万方':'计容建面：-',
                    '容积率：'+data.volume || '-',
                    data.heightLimit?'限高：'+data.heightLimit + 'm':'限高：-',
                ]
                this.shuomin = [
                    {title:'全部项目',value:[{
                            value11:'区位规划',
                            value12:data.regionalPlan || '-',
                            value21:'规划利好',
                            value22:data.forPlan || '-',
                            value31:'板块属性',
                            value32:data.landProperty || '-',
                        }]
                    },
                    {title:'配套设施',value:[{
                            value11:'交通',
                            value12:data.traffic || '-',
                            value21:'教育',
                            value22:data.education || '-',
                            value31:'医疗',
                            value32:data.medical || '-'
                        }]
                    }
                ]
            })

            // 初始化图标
            this.nvatitle1[0].img = require('../../assets/vritem/ui'+(1)+'.svg')
        },
        methods: {
            // 跳转全景
            toVR(item,i){
                console.log('跳转vr',item+'|'+i)
                // this.$router.push({path: '/vrview' ,query: {url:this.urlDataf[activeIndex].vrImgUrl,type:this.urlDataf[activeIndex].type}})
                this.$router.push({path: '/vrview' ,query: {url:this.vrUrlData[i],type:this.queryData.vrList[i].vrType}})
            },
            // 导航图标进入
            ismousemove(e){
                this.nvatitle1[e].img = require('../../assets/vritem/ui'+(e+1)+'.svg')
            },
            // 导航图标退出
            ismouseleave(e){
                if(!this.nvatitle1[e].isClor){
                this.nvatitle1[e].img = require('../../assets/vritem/u'+(e+1)+'.svg')}
            },
            // 激活当前点击样式
            isClorC(is){
                console.log('isClorC',is)
                this.nvatitle1[is].isClor = true
                this.checkScrollData(is)
                this.nvatitle1[is].img = require('../../assets/vritem/ui'+(is+1)+'.svg')
                for(var i = 0;i < this.nvatitle1.length;i++){
                    this.nvatitle1[i].img = require('../../assets/vritem/u'+(i+1)+'.svg')
                    if(i === is){
                        continue ;
                    }
                    this.nvatitle1[i].isClor = false;
                }
            },
            // 数据赋值
            checkScrollData(i){
                switch (i) {
                    case 0:
                        this.isvrStatus = false
                        this.vrUrlData = []
                        this.scrollData = this.queryData.coverList
                        break;
                    case 1:
                        this.isvrStatus = false
                        console.log(this.scrollData)
                        this.vrUrlData = []
                        this.scrollData = this.queryData.locationList
                        console.log(this.scrollData)
                        break;
                    case 2:
                        this.isvrStatus = false
                        this.vrUrlData = []
                        this.scrollData = this.queryData.fallList
                        break;
                    case 3:
                        this.isvrStatus = false
                        this.vrUrlData = []
                        this.scrollData = this.queryData.rulesList
                        break;
                    case 4:
                        this.isvrStatus = true
                        var data = []
                        var dataurl = []
                        // vrCoverImgUrl: "https://zzoss.oss-cn-hangzhou.aliyuncs.com/3f8c81a263734396a684e46c2f388ee4.jpg"
                        // vrImgUrl: "https://720yun.com/t/98vkOb2hg7m?scene_id=58371749"
                        this.queryData.vrList.forEach((item, index)=>{
                            data.push(item.vrCoverImgUrl)
                            dataurl.push({
                                vrImgUrl:item.vrImgUrl,
                                type:item.vrType
                            })
                        })
                        this.vrUrlData = dataurl
                        this.scrollData = data
                        break;
                }
            }
        }
    }
</script>

<style scoped>
    li{
        list-style: none;
    }
    li:hover{
        cursor: default;
    }
    .font-13{

        font-size: 13px;
    }
    .el-carousel__item h3 {
        color: #475669;
        font-size: 18px;
        opacity: 0.75;
        line-height: 300px;
        margin: 0;
    }

    .el-carousel__item {
        background-color: #99a9bf;
    }
    .nullBox{
        height:50px;
    }
    .nvaItem{
        height: 656px;width: 352px; margin-left: 32px;
        border: 1px rgb(220,220,220) solid;
        border-radius: 5px;
    }
    .nvatitle{
        padding-left:30px;
        text-align: left;
        padding-top: 20px;
        display: flex;
    }
    .nvatitle1{
        text-align: left;
        /*padding-top: 20px;*/
        padding-bottom: 5px;
        display: flex;
        align-items: center;
    }
    .nvatitle1>img, .nvatitle>img{
        padding-right: 15px;
        height: 24px;
        width: 24px;
    }
    .nvatitle:hover{
        color: red;
    }

    .seeType{
        text-align: left;
        padding-left: 15px;
        margin-top: 15px;
        top: 0px;
        height: 36px;
        background: inherit;
        line-height: 36px;
        background-color: rgba(239, 239, 244, 1);
    }
    .content-info{
        padding-top: 5px;
        font-family: 'PingFangSC-Regular', 'PingFang SC', sans-serif;
        font-weight: 400;
        font-style: normal;
        font-size: 13px;
        padding-right: 15px;
        color: #333;
    }
    .content-info:nth-child(1){
        font-size: 22px;
        font-weight: 900;
        color: #000;
    }
    .xmujs{
        height: 24px;
        width: 4px;
        background-color: #ff5c38;
        margin-right: 5px ;
        border-radius: 4px;
    }
    .item-imgs{
        background-size: 100% 100%;
        min-height: 253px;
        /*min-width: 337px;*/
    }
    .el-carousel__item{
        opacity: 0.7;
    }
    .is-active{
        opacity: 1;
    }
    .el-carousel__item.is-animating{

        /*transition: opacity 1s  ease-out !important;*/
        transition: opacity 1s  ease-in-out !important;
    }
    .phone-bg{
        padding-bottom: 20px;
    }
    @media only screen and (max-width: 992px) {
        .nullBox{
            height: 24px;
        }
        .mianbaox{
            display: none;
        }
        .vrinfocrat{
            padding: 0 10px !important;
        }
        .bg-white{
            background-color: rgba(243,244,247,1) !important;
        }
        img{
            border-radius: 10px !important;
            height: 100%;
            width: 100%;
        }
        .phone-bg{
            background-color: white;
            padding: 10px;
            border-radius: 5px;
            margin-bottom: 10px;
        }
    }
</style>